import { c as _c } from "react/compiler-runtime";
import { cn } from '@/app/utils/cn';
interface ListContentProps {
  list: string[];
  className?: string;
}
export const ListContent = t0 => {
  const $ = _c(9);
  const {
    list: t1,
    className
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const list = t2;
  if (list.length === 0) {
    return null;
  }
  let t3;
  if ($[2] !== className) {
    t3 = cn("list-ul where-span:text-inline-wrap text-gray-700", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== list) {
    t4 = list.map(_temp);
    $[4] = list;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <ul className={t3}>{t4}</ul>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
function _temp(item, index) {
  return <li key={index} dangerouslySetInnerHTML={{
    __html: item
  }} />;
}